import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccordionSection } from '../workshop-jobcard-accordion/workshop-jobcard-accordion.component';
import { HelpersService } from 'src/app/services/helpers.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { WorkshopJobcardCreateService } from '../workshop-jobcard-create.service';
import { ThirdPartyService } from 'src/app/services/thirdparty.service';
import { ServiceTypeService } from 'src/app/services/service-type.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';

@Component({
  selector: 'app-workshop-jobcard-accordion-manage',
  templateUrl: './workshop-jobcard-accordion-manage.component.html',
  styleUrls: ['./workshop-jobcard-accordion-manage.component.scss', '../workshop-jobcard-accordion/workshop-jobcard-accordion.component.scss']
})
export class WorkshopJobcardAccordionManageComponent {

  @Input() jobcard: any = {};
  @Input() serviceTypes: any[] = [];
  @Input() preServiceChecklist: any[] = [];
  @Input() productSKUServiceTypeCollection: any = [];
  @Input() technicians: any[] = [];
  @Input() systemUsers: any[] = [];
  @Input() collectionsConfigured: boolean = false;
  @Input() groupBookings: boolean = false; // New input for group bookings
  @Input() jobCards: any[] = []; // New input for job cards
  @Input() goToMessaging: boolean = false; // New input for go to messaging
  @Input() isPhoneView: boolean = false;
  @Input() cancelDisabled: boolean = false;
  @Output() jobcardChange = new EventEmitter<any>();

  sections: AccordionSection[] = [];

  public tags: any[] = [];
  public linkedTags: any[] = [];
  public selectedTagIds: any[] = [];
  public showExtras = true;
  constructor(
    private helpersService: HelpersService,
    private modalService: NgbModal,
    private translate: TranslateService,
    private jobcardCreateService: WorkshopJobcardCreateService,
    private thirdPartyService: ThirdPartyService,
    private serviceTypeService: ServiceTypeService,
    private serviceRequest: ServiceRequestService,
  ) {

  }

  ngOnInit() {
    this.initializeSections();
  }

  private initializeSections() {
    if (!this.isPhoneView) {
      this.sections = [
        {
          id: 'live-status-updates',
          title: '',
          isOpen: true,
          hasSettings: false,
          required: false,
          hasHeader: false
        },
        {
          id: 'live-updates',
          title: this.translate.instant('bikeshop.workshop.jobcard.services_and_products'),
          isOpen: true,
          hasSettings: false,
          required: false,
          hasHeader: false
        },
        // {
        //   id: 'services-products',
        //   title: this.translate.instant('bikeshop.workshop.jobcard.services_and_products'),
        //   isOpen: true,
        //   hasSettings: true,
        //   isCompleted: this.jobcardCreateService.isProductsAndServicesSectionCompleted(this.jobcard) || false,
        //   required: true,
        //   hasHeader: true
        // },
        {
          id: 'notes',
          title: this.translate.instant('bikeshop.workshop.jobcard.manage.notes_overview'),
          isOpen: true,
          hasSettings: false,
          required: false,
          hasHeader: true
        },
        {
          id: 'extras',
          title: this.translate.instant('bikeshop.workshop.jobcard.extras'),
          isOpen: true,
          hasSettings: false,
          required: false,
          hasHeader: true
        },
      ];
    }
    else {
      this.sections = [
        {
          id: 'live-updates',
          title: this.translate.instant('bikeshop.workshop.jobcard.services_and_products'),
          isOpen: true,
          hasSettings: false,
          required: false,
          hasHeader: false
        },
        {
          id: 'quote',
          title: '',
          isOpen: true,
          hasSettings: false,
          required: false,
          hasHeader: false
        },
        {
          id: 'notes',
          title: this.translate.instant('bikeshop.workshop.jobcard.manage.notes_overview'),
          isOpen: true,
          hasSettings: false,
          required: false,
          hasHeader: true
        },
        {
          id: 'extras',
          title: this.translate.instant('bikeshop.workshop.jobcard.extras'),
          isOpen: true,
          hasSettings: false,
          required: false,
          hasHeader: true
        },
      ];
    }
  }

  onJobCardChange(event: any): void {
    this.jobcardChange.emit(event);
    //this.updateSectionValidation();
  }

  toggleSection(sectionId: string, event?: Event): void {
    if (event) {
      event.stopPropagation();
    }

    const section = this.sections.find(s => s.id === sectionId);
    if (section) {
      section.isOpen = !section.isOpen;
    }
  }

  buttonEnabled(sectionId: string): boolean {
    const section = this.getSectionById(sectionId);
    if (!section) return false;

    switch (sectionId) {
      case 'item-details':
        return this.jobcard.customer && (this.jobcard.customer.ID || this.jobcard.customer.Email || this.jobcard.customer.PhoneNumber);
      case 'booking-details':
      case 'collections-deliveries':
      //return this.jobcard.selectedItem && !this.jobcard.itemIsHere;
      default:
        return true; // Default to true for other sections
    }
  }

  getSectionById(sectionId: string): AccordionSection | undefined {
    return this.sections.find(s => s.id === sectionId);
  }

  onAddClick(sectionId: string, event: Event): void {
    if (event) {
      event.stopPropagation();
    }

    switch (sectionId) {

    }
  }

  setTagCount(event) {
    console.log('setTagCount', event); 
    if (event == 0) {
      this.showExtras = false;
      this.sections.splice(this.sections.findIndex(s => s.id === 'extras'), 1);
    }
  }

}
